import { useContext } from 'react'
import { PushNotificationDeviceRegistrationContext } from '../../App'


export function useCurrentPushNotificationDeviceRegistration() {
  const deviceRegistration = useContext(PushNotificationDeviceRegistrationContext)

  return deviceRegistration
}
